import { render, staticRenderFns } from "./onlineServices.vue?vue&type=template&id=035f130c"
import script from "./onlineServices.vue?vue&type=script&lang=js"
export * from "./onlineServices.vue?vue&type=script&lang=js"
import style0 from "./onlineServices.vue?vue&type=style&index=0&id=035f130c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./onlineServices.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports